import { DictionariesControllerApi, IabCategoryBean, LanguageBean, TimeZoneBean, CountryBean, DictionaryOption } from '../api/api';
import { BaseApi, configuration }                                                                           from '../api/BaseApi';
import { processError }                                                                                     from '../api/customFetch';

class DictionariesApi extends BaseApi {
    api: DictionariesControllerApi;

    constructor() {
        super();
        this.api = new DictionariesControllerApi(configuration, configuration.basePath, this.customFetch);
    }

    iabCategories(): Promise<Array<IabCategoryBean>> {
        return this.api.iabCategories().then(cats => {
            return Promise.resolve(cats);
        }).catch(err => {
            return processError(err);
        });
    }
    countries(): Promise<Array<CountryBean>> {
        return this.api.countries().then(list => {
            return Promise.resolve(list);
        }).catch(err => {
            return processError(err);
        });
    }

    languages(): Promise<Array<LanguageBean>> {
        return this.api.language().then(list => {
            return Promise.resolve(list);
        }).catch(err => {
            return processError(err);
        });
    }

    timezones(): Promise<Array<TimeZoneBean>> {
        return this.api.timezone().then(list => {
            return Promise.resolve(list);
        }).catch(err => {
            return processError(err);
        });
    }


    deviceTypeList(): Promise<DictionaryOption[]> {
        return (this.api.deviceType() as unknown as Promise<DictionaryOption[]>)
            .then((list) => Promise.resolve(list ?? []))
            .catch(err => processError(err));
    }


    operatingSystems(): Promise<DictionaryOption[]> {
        return (this.api.os() as unknown as Promise<DictionaryOption[]>)
            .then((list) => Promise.resolve(list ?? []))
            .catch(err => processError(err));
    }
}

const dictionariesApi = new DictionariesApi();

export default dictionariesApi;
